import {
    EDIT_ANNOTATION_REQUEST,
    EDIT_ANNOTATION_SUCCESS,
    EDIT_ANNOTATION_FAILURE
} from '../actions';


const initialState = {};

const EditAnnotationReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ANNOTATION_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case EDIT_ANNOTATION_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case EDIT_ANNOTATION_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default EditAnnotationReducer;